import api from '../api'

export default {
  editUserInfo (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/user/editUserInfo', data, successCallback, errCallback, isShowErrMsg)
  },
  bindMobilePhone (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/user/userBindMobilePhone', data, successCallback, errCallback, isShowErrMsg)
  },//
  initSetPassword (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/user/initSetPassword', data, successCallback, errCallback, isShowErrMsg)
  },
  editPassword (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/user/editPassword', data, successCallback, errCallback, isShowErrMsg)
  },
  uploadUserIcon (data, successCallback, errCallback = function () {}, isShowErrMsg = true) {
    api.post('api/appclient/v2/file/upload', data, successCallback, errCallback, isShowErrMsg)
  }
}



// WEBPACK FOOTER //
// ./src/api/mine/api.mine.js